import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "../pages/Layout";
import PageSkeleton from "../components/ui/PageSkeleton";
import { PageTransition } from "../motion";

const HomePage = lazy(() => import("../pages/HomePage"));
const CardPage = lazy(() => import("../pages/CardPage"));
const MarketplacePage = lazy(() => import("../pages/MarketplacePage"));
const AgentPage = lazy(() => import("../pages/AgentPage"));
const AboutUsPage = lazy(() => import("../pages/AboutUsPage"));
const FAQ = lazy(() => import("../components/FAQ/FAQ"));
const ContactUsPage = lazy(() => import("../pages/ContactUsPage"));
const PrivacyPolicy = lazy(() => import("../components/PrivacyPolicy/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../components/TermsAndConditions/TermsAndConditions"));
const RefundAndCancellation = lazy(() => import("../components/RefundAndCancellation/RefundAndCancellation"));
const GrievanceRedressal = lazy(() => import("../components/GrievanceRedressal/GrievanceRedressal"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={<PageSkeleton />}>
                <Routes>
                    <Route element={<Layout />}>
                        <Route element={<PageTransition />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/card" element={<CardPage />} />
                            <Route path="/marketplace" element={<MarketplacePage />} />
                            <Route path="/ai-agents" element={<AgentPage />} />
                            <Route path="/about-us" element={<AboutUsPage />} />
                            <Route path="/faqs" element={<FAQ />} />
                            <Route path="/contact-us" element={<ContactUsPage />} />
                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                            <Route path="/refund-and-cancellation" element={<RefundAndCancellation />} />
                            <Route path="/grievance-redressal-policy" element={<GrievanceRedressal />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default AppRoutes;
